import React, {useContext, useEffect, useRef} from "react";
import {socketService} from "../services/socket/socket.service";
import {useAccount} from "wagmi";
import {ToasterContext} from "../context-providers/ToasterProvider/ToasterProvider";
import {IDeposit, IWithdrawal} from "../services/api/api.interfaces";
import {ServicesContext} from "../context-providers/ServicesProvider";

export const useSocket = () => {
    const { address } = useAccount();
    const socket: any = useRef();
    const [isConnected, setIsConnected] = React.useState(false);
    const { addToasterWithStatusAndDescription } = useContext(ToasterContext);
    const { depositWithdrawService } = useContext(ServicesContext);

    function handleAccountDeposit(deposit: IDeposit) {
        console.log('handleAccountDeposit', deposit)
        if (deposit.status === 'PENDING') {
            addToasterWithStatusAndDescription({
                id: deposit.txHash,
                status: 'pending',
                title: 'Depositing USDC',
                description: depositWithdrawService.getDepositToasterDescription(),
            });
        } else if (deposit.status === 'CONFIRMED') {
            addToasterWithStatusAndDescription({
                id: deposit.txHash,
                status: 'success',
                title: 'Depositing USDC',
                description: depositWithdrawService.getDepositToasterDescription(),
                closeTime: 10000,
            });
        }

    }
    function handleAccountWithdrawal(withdrawal: IWithdrawal) {
        console.log('handleAccountWithdrawal', withdrawal)
        if (withdrawal.status === 'DONE') {
            addToasterWithStatusAndDescription({
                id: `withdrawal:${withdrawal.id}`,
                status: 'success',
                title: 'Withdraw USDC',
                description: depositWithdrawService.getWithdrawToasterDescription(),
                closeTime: 10000,
            });
        }

    }

    useEffect(() => {
        if (socket.current) {
            return;
        }
        socket.current = socketService.connect();
        socket.current.on('account:deposit', handleAccountDeposit)
        socket.current.on('account:withdrawal', handleAccountWithdrawal)

        socket.current.on('connect', () => {
            setIsConnected(true);
        });

        socket.current.on('disconnect', () => {
            setIsConnected(false);
        });


    }, []);

    useEffect(() => {
        if (!isConnected) {
            return;
        }
        if (address) {
            console.log('subscribing on user data', address);
            socketService.subscribeToUserData(address);
        } else {
            socketService.unsubscribeFromPositions();
        }

    }, [address, isConnected]);
}